import React from "react"
import { Table, Tooltip, Button, Tag, Typography } from 'antd'
import { StarOutlined } from '@ant-design/icons';
import { snakeCase } from 'lodash'

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";
import { formatDateTime } from "../../helpers/date";

const { Text } = Typography;

const PricingPackageLabelList = props => {
  const { permissions } = usePermissions();

  const setDefaultHandler = id => {
    props.onSetDefault(id)
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Key",
      dataIndex: "name",
      render: (name) => (
        <Tooltip title="This is the exact value stored on Pricing/Cost rows, and must match the uploaded Excel sheet name.">
          <Text code>{snakeCase(name)}</Text>
        </Tooltip>
      ),
    },
    {
      title: "Default",
      dataIndex: "isDefault",
      render: (isDefault, record) => isDefault ? (
        <Tag color="blue">Default</Tag>
      ) : (
        permissions?.includes(PERMISSIONS.UPDATE_PRICING_PACKAGE_LABEL) && (
          <Tooltip title="Set as default for this category">
            <Button
              size="small"
              icon={<StarOutlined />}
              onClick={() => setDefaultHandler(record.objectId)}
            >
              Set Default
            </Button>
          </Tooltip>
        )
      ),
    },
    {
      title: "Added",
      dataIndex: "createdAt",
      render: (text) => formatDateTime(text),
    },
    {
      title: "Updated",
      dataIndex: "updatedAt",
      render: (text) => formatDateTime(text),
    },
  ];

  return (
    <div className="table">
      <Table
        rowKey="objectId"
        className="table-section"
        columns={columns}
        dataSource={props.labels}
        pagination={false}
        scroll={{ x: true }}
        loading={props.loading}
      />
    </div>
  )
}

export default PricingPackageLabelList
